/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * GlobeIcon
 */
export default class GlobeIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M13 1v.045C18.608 1.55 23 6.262 23 12s-4.393 10.45-10 10.955v.07L12.011 23h-.023l-.988.025v-.07C5.394 22.45 1 17.738 1 12S5.394 1.55 11 1.045V1h2zm2.311 17H13v2.756l.088-.043c.847-.45 1.625-1.408 2.223-2.712zM11 18H8.689c.598 1.305 1.376 2.262 2.223 2.713l.088.043V18zm7.708 0l-1.232.001c-.228.603-.49 1.166-.783 1.68a9.05 9.05 0 002.015-1.68zm-12.184.001H5.292a9.044 9.044 0 002.015 1.68 11.884 11.884 0 01-.783-1.68zm-.998-5H3.055a8.94 8.94 0 00.881 3H5.93a17.94 17.94 0 01-.404-3zM11 13H7.529a15.68 15.68 0 00.46 3.001L11 16v-3zm5.471 0H13v3l3.011.001c.237-.919.398-1.93.46-3zm4.474 0h-2.47a17.94 17.94 0 01-.405 3l1.994.001a8.94 8.94 0 00.881-3zM5.93 8H3.936a8.94 8.94 0 00-.881 3h2.47c.055-1.046.193-2.054.405-3zM11 8H7.988a15.674 15.674 0 00-.46 3H11V8zm5.012 0H13v3h3.471a15.674 15.674 0 00-.46-3zm4.052 0H18.07c.212.946.35 1.954.404 3h2.471a8.94 8.94 0 00-.88-3zM7.302 4.322l-.127.08c-.7.444-1.333.983-1.884 1.598h1.232c.226-.602.487-1.164.779-1.678zM11 3.243l-.118.06C10.047 3.762 9.28 4.71 8.688 6H11V3.243zm2 0V6h2.312c-.555-1.21-1.265-2.12-2.04-2.606l-.154-.09L13 3.243zm3.698 1.08l.08.143c.26.475.494.988.7 1.534h1.23a9.044 9.044 0 00-2.01-1.678z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

